import { ToastContainer, Slide, TypeOptions } from "react-toastify";
import { CheckCircle, XCircle, Zap, AlertCircle } from "react-feather";

import styles from "./toaster.module.css";

const contextClass: Record<TypeOptions, string> = {
  success: styles.success,
  error: styles.error,
  info: styles.info,
  default: styles.default,
  warning: styles.warning,
};

export default function Toaster() {
  return (
    <ToastContainer
      toastClassName={(context) =>
        `${contextClass[context?.type || "default"]} ${styles.toast}`
      }
      position="bottom-center"
      autoClose={8000}
      icon={({ type }) => {
        switch (type) {
          case "info": {
            return <Zap size={20} className={styles.infoIcon} />;
          }
          case "error": {
            return <XCircle size={20} className={styles.errorIcon} />;
          }
          case "success": {
            return <CheckCircle size={20} className={styles.checkCircle} />;
          }
          case "warning": {
            return <AlertCircle size={20} className={styles.warningIcon} />;
          }
          default: {
            return <Zap size={20} className={styles.infoIcon} />;
          }
        }
      }}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
      transition={Slide}
    />
  );
}
